var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_399",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28867",
    "data-name": "Group 28867",
    transform: "translate(-4773 6237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4773, -6237)",
    filter: "url(#Ellipse_399)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_399-2",
    "data-name": "Ellipse 399",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_3_",
    "data-name": "svgexport-17 (3)",
    transform: "translate(4792 -6220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49751",
    "data-name": "Path 49751",
    d: "M33.819,23.53,23.176,21.983l-4.76-9.644a1.138,1.138,0,0,0-2.04,0l-4.76,9.644L.974,23.53a1.138,1.138,0,0,0-.63,1.94l7.7,7.507-1.818,10.6a1.137,1.137,0,0,0,1.65,1.2l9.519-5c10.364,5.448,9.652,5.135,10.048,5.135a1.138,1.138,0,0,0,1.121-1.33l-1.818-10.6,7.7-7.507a1.138,1.138,0,0,0-.63-1.94Z",
    transform: "translate(0 -11.705)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49752",
    "data-name": "Path 49752",
    d: "M17.4,11.689a1.138,1.138,0,0,0-1.02.634l-4.76,9.644L.974,23.514a1.138,1.138,0,0,0-.63,1.94l7.7,7.507L6.227,43.56a1.137,1.137,0,0,0,1.65,1.2l9.519-5h0Z",
    transform: "translate(0 -11.689)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49753",
    "data-name": "Path 49753",
    d: "M.974,164.484a1.138,1.138,0,0,0-.63,1.94l7.7,7.507-1.818,10.6a1.137,1.137,0,0,0,1.65,1.2l9.519-5c10.364,5.448,9.652,5.135,10.048,5.135a1.137,1.137,0,0,0,.669-.217l-16.5-22.706Z",
    transform: "translate(0 -152.659)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49754",
    "data-name": "Path 49754",
    d: "M12.134,187.556c-8.249-8.041-7.895-7.61-8.005-8.027a1.154,1.154,0,0,1-.005-.568l-3.149.458a1.138,1.138,0,0,0-.63,1.94l7.7,7.507-1.818,10.6a1.137,1.137,0,0,0,1.65,1.2l2.8-1.471a1.137,1.137,0,0,1-.36-1.037Z",
    transform: "translate(0 -167.594)",
    fill: "#f48b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49755",
    "data-name": "Path 49755",
    d: "M.4,198.252l7.7,7.507-1.818,10.6a1.137,1.137,0,0,0,1.65,1.2l9.519-5c10.364,5.448,9.652,5.135,10.048,5.135a1.138,1.138,0,0,0,1.121-1.33l-1.818-10.6L.113,197.086A1.138,1.138,0,0,0,.4,198.252Z",
    transform: "translate(-0.057 -184.487)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49756",
    "data-name": "Path 49756",
    d: "M.4,198.252l7.7,7.507-1.818,10.6a1.137,1.137,0,0,0,1.65,1.2l2.8-1.471a1.137,1.137,0,0,1-.36-1.037l1.818-10.6L6.9,199.291l-6.786-2.2A1.138,1.138,0,0,0,.4,198.252Z",
    transform: "translate(-0.057 -184.487)",
    fill: "#efb616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49757",
    "data-name": "Path 49757",
    d: "M91.408,216.36a1.137,1.137,0,0,0,1.65,1.2l9.519-5c10.364,5.448,9.652,5.135,10.048,5.135a1.138,1.138,0,0,0,1.121-1.33l-1.818-10.6,7.7-7.507a1.138,1.138,0,0,0,.288-1.166L93.226,205.76Z",
    transform: "translate(-85.181 -184.488)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49758",
    "data-name": "Path 49758",
    d: "M91.408,317.156a1.137,1.137,0,0,0,1.65,1.2l2.8-1.471a1.137,1.137,0,0,1-.36-1.037l1.818-10.6-.015-.014-4.074,1.324Z",
    transform: "translate(-85.181 -285.284)",
    fill: "#f48b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49759",
    "data-name": "Path 49759",
    d: "M99.49,185.73l9.519-5c10.364,5.448,9.652,5.135,10.048,5.135a1.138,1.138,0,0,0,1.121-1.33l-1.818-10.6,7.7-7.507a1.138,1.138,0,0,0-.63-1.94l-10.643-1.546-16.5,22.706A1.138,1.138,0,0,0,99.49,185.73Z",
    transform: "translate(-91.613 -152.66)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49760",
    "data-name": "Path 49760",
    d: "M126.35,197.086l-17.341,5.634L98.292,217.471a1.137,1.137,0,0,0,1.2.087l9.519-5c10.364,5.448,9.652,5.135,10.048,5.135a1.138,1.138,0,0,0,1.121-1.33l-1.818-10.6,7.7-7.507A1.138,1.138,0,0,0,126.35,197.086Z",
    transform: "translate(-91.613 -184.487)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49761",
    "data-name": "Path 49761",
    d: "M118.361,283.037,109.009,280,98.292,294.749a1.137,1.137,0,0,0,1.2.087l9.519-5c10.364,5.448,9.652,5.135,10.048,5.135a1.138,1.138,0,0,0,1.121-1.33l-1.818-10.6Z",
    transform: "translate(-91.613 -261.765)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49762",
    "data-name": "Path 49762",
    d: "M98.292,294.749a1.137,1.137,0,0,0,1.2.087l9.519-5c10.364,5.448,9.652,5.135,10.048,5.135a1.137,1.137,0,0,0,.669-.217L109.009,280Z",
    transform: "translate(-91.613 -261.765)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49763",
    "data-name": "Path 49763",
    d: "M109.009,280h0L98.292,294.749a1.137,1.137,0,0,0,1.2.087l9.519-5h0Z",
    transform: "translate(-91.613 -261.765)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49764",
    "data-name": "Path 49764",
    d: "M102.508,411.665l-4.216,5.8a1.137,1.137,0,0,0,1.2.087l2.8-1.471a1.137,1.137,0,0,1-.36-1.037l.58-3.382Z",
    transform: "translate(-91.613 -384.485)",
    fill: "#efb616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ed0ca2b22665f4e613bcb7b7192130cb.svg";
export { ForwardRef as ReactComponent };